import React, { useEffect, useState } from "react";
import SportCode from "components/common/SportCode";
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";

import Label from "components/general/Label"
import DateTime from "components/presentation/DateTime"
import { isLiveStatus, isLessLiveStatus } from "helpers/status";
import Status from "components/presentation/Status";
import Noc from "components/presentation/Noc";
import Competitor from "components/presentation/Competitor";
import { getDateTimeFormat } from "helpers/utils";




export function CompetitorBlock(competitor) {
    return (
        <div className="d-flex">
            <Noc {...competitor?.participant?.organisation} showOnlyImage={true} showImgAlt={false} />
            <Competitor  {...competitor?.participant} hideNoc={true} hidePicture={true} noLink={true} onlyShortName={true} screen={competitor.screen} />
        </div>
    )
}
export function CompetitorBlockNoData(competitor) {
    const { mirs_discipline } = useUrlFriendlyToParameters()
    const sportSCPrint = ['FBL', 'HBL']
    let out;
    if (competitor?.cp_code === 'BYE') {
        out = <SportCode discipline={mirs_discipline} entity='@CompetitorPlace' code={competitor?.cp_code} notFound={<>&nbsp;</>} />
    } else if (competitor?.cp_prev_wlt && competitor?.cp_prev_value) {
        out = <><SportCode discipline={mirs_discipline} entity='@WLT' code={competitor?.cp_prev_wlt} /> {competitor?.cp_prev_value}</>
    } else if (competitor?.cp_prev_value) {
        out = sportSCPrint.includes(mirs_discipline) ? <SportCode discipline={mirs_discipline} entity='@Pool' code={competitor?.cp_prev_value} /> : competitor?.cp_prev_value
    } else if (competitor?.cp_code) {
        out = <SportCode discipline={mirs_discipline} entity='@CompetitorPlace' code={competitor?.cp_code} notFound={<>&nbsp;</>} />
    }
    return (
        <div className=' d-flex flex-row justify-content-start'>
            <div className=''>
                {out}
            </div>
        </div>
    )
}

export function Footer({ data }) {


    const formatDate = getDateTimeFormat('DayMonthShort')
    const formatDateTime = getDateTimeFormat('DayMonthShortHourMinute');
    const dateTime = data?.bi_date + ' ' + data?.bi_time
    const dateTimeFormated = data?.bi_date && <DateTime datetime={dateTime} format={formatDateTime} />
    const date = data?.bi_date && <><DateTime datetime={data?.bi_date} format={formatDate} /></>
    const dateComponent = data?.bi_time ? dateTimeFormated : date
    const numberGame = data?.bracketItemCode
    let isLive = isLiveStatus(data?.result?.status?.code);
    let isLessLive = isLessLiveStatus(data?.result?.status?.code);
    const { mirs_discipline } = useUrlFriendlyToParameters()
    return (
        <>
            {isLive && <div className='score-status justify-content-end w-100'>
                <Status typeToPrint={'result'} scheduleStatus={data?.schedule?.status?.code} resultStatus={data?.result?.status?.code} />
            </div>}
            <div className="d-flex w-100">
                {isLessLive && <div className='text-start w-50'>{dateComponent ? dateComponent : 'TBD'}</div>}
                {isLessLive && <div className='text-end w-50'>{mirs_discipline === 'GBL' ? <Label data='HeaderGame' /> : <Label data='HeaderMatch' />} {numberGame}</div>}
            </div>
        </>
    )
}



